import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import {
  Dialog,
  DialogType,
  DialogFooter,
} from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Link } from 'office-ui-fabric-react/lib/Link';

import { localizable } from '../../../components/Localization';

@localizable
@observer
export default class OfferNotificationDetails extends Component {
  @observable isOpen = false;

  render() {
    const { t, item } = this.props;
    const open = () => (this.isOpen = true);
    const close = () => (this.isOpen = false);

    return (
      <span>
        &nbsp;&nbsp;
        <Link onClick={open}>
          <Icon iconName="Zoom" />
        </Link>
        {this.isOpen && (
          <Dialog
            hidden={false}
            dialogContentProps={{
              type: DialogType.largeHeader,
              onDismiss: close,
              title: t('Service Data'),
            }}
            modalProps={{
              isBlocking: true,
              containerClassName: 'ms-dialogMainOverride ms-dialogWideOverride',
            }}
          >
            <div>
              <pre>{item.serviceData}</pre>
            </div>
            <DialogFooter>
              <PrimaryButton onClick={close} text={t('Close')} />
            </DialogFooter>
          </Dialog>
        )}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/OfferNotificationDetails.jsx